<template>
  <div>
    <qx-table v-if="configs.length != 0" class="table" :data="list" v-bind="$attrs" v-on="$listeners"
        :span-method="spanMethod" :summary-method="getSummaries" @sort-change="onSortChange">
      <el-table-column v-for="config in configs" :key="config.prop" v-bind="config">
        <template  slot="header" slot-scope="scope">
            <label>{{config.label}}</label>
            <el-tooltip v-if="config.tip" style="font-size: 14px;line-height: 20px" effect="light"
                      placement="top"
                      :content="config.tip">
                      <i class="el-icon-question"></i>
            </el-tooltip>
          </template>
      </el-table-column>
    </qx-table>
    <!-- <qx-table v-if="showCompareSummary" class="table compare" :data="summary" :show-header="false"
        :span-method="summarySpanMethod" row-class-name="row-summary">
      <el-table-column v-for="config in configs" :key="config.prop" v-bind="config"/>
    </qx-table> -->
    <div style="height: 10px"></div>

    <BasePagination :total="total" @action="doAction" :curPage.sync="curPage" :pageSize="50" :pageSizes="[50]" @updateCurPage="updateCurPage"  ></BasePagination>

  </div>
</template>
<script>
   

  import QxTable from '@/components/common/qx-table.vue'
  import BasePagination from '../BasePagination'

  export default {
    components: {
        QxTable, BasePagination
    },
    props: {
      list: Array,
      cols: Array,
      tableProps: Array,
      summary: Array,
      dimensionLength: Number,
      compare: Boolean,
      curPage: Number,
      total: Number
    },
    data:  function () {
      return {
        paginationConfig: {
        },
      }
    },
    computed: {
      // advertiserId: function () {
      //   return this.$route.params.advertiserId;
      // },
      windowHeight: function () {
        return this.$store.state.windowHeight;
      },
      // showCompareSummary: function () {
      //   return this.compare && this.summary && this.summary.length > 0;
      // },
      // tableHeight: function () {
      //   return this.showCompareSummary ? this.windowHeight - 140 : this.windowHeight - 40;
      // },
      configs: function () {
        if (!this.cols || this.cols.length == 0) {
          return [];
        }
        let res = [];
        let tableProps = this.tableProps || [];
        for (let config of tableProps) {
          let colName = config.prop;
          let cfg = { ...config };
          if (this.cols.indexOf(colName) >= 0 || config.required) {
            res.push(cfg);
          }
        }
        return res;
      }
    },
    methods: {
      updateCurPage: function (param) {
        this.$emit('updateCurPage', param)
      },
      getSummaries: function (param) {
        let summary = (this.summary || [])[0] || {};
        let dimensionLength = this.dimensionLength || 0;
        let { columns } = param;
        let sums = [];
        columns.forEach((column, index) => {
          if (index == 0) {
            sums[index] = '总计';
            return;
          }
          if (index < dimensionLength) {
            sums[index] = '';
            return;
          }
          sums[index] = format(summary[column.property]);
        });
        return sums;
      },
      spanMethod: function ({ row, column, rowIndex, columnIndex }) {
        let list = this.list || [];
        let item = list[rowIndex];
        return column.property == 'advertiserName' ? [item.rowspan, item.colspan] : [1, 1];
      },
      summarySpanMethod: function ({ row, column, rowIndex, columnIndex }) {
        return columnIndex == 0 ? [1, this.dimensionLength] : columnIndex < this.dimensionLength ? [0, 0] : [1, 1];
      },
      doAction: function (action) {
          //todo
        this.$emit('action', action);
      },
      onSortChange: function ({column, prop, order}) {
        console.log(column)
        console.log(prop)
        console.log(order)
        this.$emit("sortChange", prop, order)
      }
    }
  }

   function format(cellValue) {
     return cellValue == null || cellValue == 'NaN' || cellValue == 'Infinity' ? '-' :
       parseFloat(cellValue).toLocaleString('en-US');
   }
</script>
<style scoped>
  .compare {
    margin-top: 10px;
  }
</style>